import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { Message } from "../../../model/Auth";
import { Order, UpdateOrderModel } from "../../../model/Order";
import { ResponseState, State } from "../../../model/ResponseState";

export interface UpdateOrderUseCase {
  invoke: (
    id: string,
    model: UpdateOrderModel
  ) => Promise<ResponseState<Message>>;
}

export class UpdateOrderUseCaseImpl implements UpdateOrderUseCase {
  private repository: OrderRepository;

  constructor(repository: OrderRepository) {
    this.repository = repository;
  }

  async invoke(
    id: string,
    model: UpdateOrderModel
  ): Promise<ResponseState<Message>> {
    try {
      let response = await this.repository.update(id, model);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
